import { render, staticRenderFns } from "./Middlemans.vue?vue&type=template&id=0d9e727c&"
import script from "./Middlemans.vue?vue&type=script&lang=js&"
export * from "./Middlemans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports